import { inventoryTxFromFirestore } from '@parallel-fluidics/shared/models/inventory';
import {
  collection,
  getFirestore,
  orderBy,
  where,
} from 'firebase/firestore';
import useCustomInfiniteQuery from 'hooks/use-customInfiniteQuery';
import { useMemo } from 'react';

const PAGE_SIZE = 20;

export default function useInventoryTxQuery(productDocId, productVersionId) {
  const queryParams = useMemo(() => {
    if (!productDocId || !productVersionId) return null;
    return [
      collection(getFirestore(), 'inventoryTx'),
      where('productDocId', '==', productDocId),
      where('productVersionId', '==', productVersionId),
      orderBy('createdAt', 'desc'),
    ];
  }, [productDocId, productVersionId]);

  return useCustomInfiniteQuery({
    queryKey: `inventoryTx_${productDocId}_${productVersionId}`,
    queryParams: queryParams ?? [],
    pageSize: queryParams ? PAGE_SIZE : 0,
    transformData: inventoryTxFromFirestore,
  });
}
